export default {
    admin: {
        title: "Admin",
        futureScreen: "Future screen",
        freqMappings: {
            title: "Frequency mappings",
            frequency: "Frequency (MHz)",
            name: "Name",
            addRow: "Add row",
            deleteSelectedRows: "Delete selected rows",
            refresh: "Refresh to server",
            nameRuleRequired: "Name is required",
            nameRuleUnique: "This name is already mapped",
            freqRuleRequired: "Frequency is required",
            freqRuleNumberMultiple: "Frequency must be a multiple of 6250 Hz",
            freqRuleMin: "Frequency must greater than or equal to 409.6 MHz",
            freqRuleUnique: "This frequency is already mapped",
            frequencyAlreadyMapped: "Frequency '{frequency}' is already mapped",
            frequencyNameAlreadyMapped: "Frequency name '{name}' is already mapped to another frequency",
            frequencyNotMultiple: "Invalid frequency:  frequency must be a multiple of 6250 Hz",
            freqRuleMHz: "Frequency value is too large, please enter in MHz",
            mappingDeleted: "Mapping deleted",
            mappingDeletedError: "Error deleting mapping",
            mappingSaved: "Mapping saved",
            mappingSavedError: "Error saving mapping",
            mappingUpdated: "Mapping updated",
            mappingUpdatedError: "Error updating mapping",
            noRowsToShow: "No rows to show",
            mappingIncompleteError: "Mapping was invalid or missing values, unable to save"
        },
        ncsManagementTab:{
            title: "NCS Management",
            primary:"Primary",
            secondary:"Secondary",
            null:"Not Set"
        },
        btsManagementTab:{
            title:"Base Station Configuration Management",
            description: "Change how NCS manages the towers configuration",
        },
        currentInstance:{
            title:"Current Role",
            discription:"Current Base Station Management Role",
            fetchError:"Error occured while fetching current base station management role",
            change:{
                title:"Change Base Station Management Role",
                msg:"Confirm you want to change this NCS instance to {msg}",
                error:"Failed to Change Base Station Management Role to {msg}",
                success:"Base Station Management Role Updated"
            }
        },
        altCertsUrl:{
            title:"Secondary NCS URL",
            description: "URL for certs verification",
            fetchError:"Error occurred while Alternative CA Public Key URL",
            change:{
                title:"Enter Secondary NCS URL",
                confirmTitle:"Change Secondary NCS URL",
                msg:"Confirm you want to change Secondary NCS URL to {msg}",
                error:"Failed. {msg}",
                success:"Secondary NCS URL Updated"
            }
        },
        outboundManagement: {
            bulkActions: {
                confirmation: {
                    title: "Confirm Bulk Action",
                    message: "Are you sure you want to {mode}?"
                },
                ENABLED: {
                    button: "Enable All",
                },
                DISABLED: {
                    button: "Disable All",
                },
                ENABLED_READ_ONLY: {
                    button: "Set All to Read-Only",
                }
            },
            netTuneTitle: "NetTune Management",
            netConfigTitle: "NetConfig Management",
            featureModes: {
                statusDropdown: {
                    title: "Outbound Traffic Status",
                    subtitle: "System-wide features that interact with endpoints.",
                    btn: "Manage Outbound Traffic",
                    noFeatures: "There are no {status} features.",
                },
                selectiveEnabled: "Selective Enabled",
                features: "Features",
                readOnly: "Read-Only",
                enabled: "Enabled",
                disabled: "Disabled",
                enabled_read_only: "Read-Only",
                mode: "Mode",
                selectValidationError: "{feature} cannot be {featureVal} when {featureDep} is {depVal}.",
                USER_COMMANDS_NETCONFIG: {
                    title: "Base Station User Commands",
                    description: "Manage the Commanding infrastructure that dispatches to base stations."
                },
                SPR_RAPID_TUNE: {
                    title: "Rapid Tuning",
                    description: "A feature that rapidly assesses a newly discovered (usually newly installed) endpoints and moves it from the administrative channel to available bulk channel pairs.",
                },
                ETL: {
                    title: "ETL",
                    description: "Extract the base station data from NCS, transform, and load those data to RNI DB table dim_tgb and tower_channels ",
                },
                USER_COMMANDS: {
                    title: "Endpoint User Commands",
                    description: "Manage the ability for a user to manually send setup or ping commands to an endpoint.",
                },
                TUNING_CHAIN_TUNING_CB: {
                    title: "Channel Balancing",
                    description: "Channel balancing is an iterative process of moving endpoints between channels.",
                },
                TUNING_CHAIN_BUDDY_CONFIG: {
                    title: "Buddy Config",
                    description: "Tuning Chain Buddy Configurations vital buddies, static rebroadcasters, etc.",
                },
                TUNING_CHAIN_BUDDY_DIST: {
                    title: "Buddy Distribution",
                    description: "Part of the tuning chain job. It ensures that in a given hexagon with a 0.5 mile radius, at least one buddy is in admin channel.",
                },
                TUNING_CHAIN_TUNING_NCO: {
                    title: "Network Capacity Optimization",
                    description: "NCO utilizes the rules engine to execute customer defined rules and determine tuning configuration.",
                },
                SPR_LATENT_TOWER_SS_REPORT_PINGER: {
                    title: "Latent Base Station Report Pinger",
                    description: "Monitors and sends pings when no Full Base Station Signal Strength Report is received from an endpoint during the minimum latency hours timeframe."
                },
                SPR_LATENT_ORD_PINGER: {
                    title: "Latent ORD Pinger",
                    description: "Monitors and sends pings when no ORD Signal Strength Report is received from an endpoint during the minimum latency hours timeframe."
                },
                PINGERS: {
                    title: "Pinger Configuration",
                    description: "Configures and manages the monitoring and pinging behavior, including Latent Base Station Report Pinger and Latent ORD Pinger, in response to missing signal strength reports from endpoints."
                }
            }
        },
        netTuneConfiguration: {
            searchPlaceholder: "Search by Features or Settings",
            description: "Fine tune the features and services that make up NetTune.",
            resetDefaults: "Reset to Defaults",
            saveChanges: "Save Changes"
        }
    }
}
